


















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import * as employeeNavigatorUrls from "@/shared/employeeNavigatorUrls";

  @Component
  export default class EmployeeNavigatorWidget extends Vue {
    EmployeeNavigatorUrls = employeeNavigatorUrls;
  }
